import React, { useState, useEffect, useRef } from "react"
import PageTitle from "../components/PageTitle";
import Index from "../view/Profile/Index";
import { useDispatch, useSelector } from "react-redux";
import ToastAlert from "../common/ToastAlert";
import ApiCall from "../common/ApiCall";
import { setLoading, setLogout, setUserDetails } from "../redux/user/user.action";
import { useLocation, useNavigate } from "react-router-dom";
import Form from "../view/Profile/Form";
import Cropper from 'cropperjs';
import { allowedImageExtensions, maxImageSize, profileImageMinHeight, profileImageMinWidth } from "../common/Config";
import CropImageModal from "../view/Profile/CropImageModal";
import flatpickr from "flatpickr";
import moment from "moment";
import { useOutletContext } from "react-router-dom";
import { validateAll } from "indicative/validator";
import HomeIcon from "../components/Iocns/HomeIcon";
import { getSlugByLang } from "../common/Helper";

export default function ProfileController() {
    const [setBreadcrumbList] = useOutletContext();
    const user = useSelector((state) => state.user);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [state, setState] = useState({
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        profile_picture: '',
        country_code: '',
        birth_date: '',
        error: [],
    })
    const [tempState, setTempState] = useState({
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        profile_picture: '',
        country_code: '',
        birth_date: '',
        error: [],
    })
    const [isEdit, setIsEdit] = useState(false)
    const inputRef = useRef(null);
    const [phone, setPhone] = useState("");
    const [phoneError, setPhoneError] = useState("");
    const [countryCode, setCountryCode] = useState("PT");
    const [initialCountry, setInitialCountry] = useState("pt");
    const [cropperInstance, setCropperInstance] = useState(null);
    const cropperImageRef = useRef(null);
    const [showModal, setShowModal] = useState(false);
    const [originalImage, setOriginalImage] = useState(null);
    const [imageName, setImageName] = useState('');
    const handleClose = () => setShowModal(false);
    const calendarRef = useRef();
    const [flatpickrInstance, setFlatpickrInstance] = useState(null);
    const [date, setDate] = useState('');
    const location = useLocation();
    const userLang = getSlugByLang(user?.language)
    useEffect(() => {
        setBreadcrumbList([
            {
                name: <HomeIcon />,
                url: '/' + userLang
            },
            {
                name: "Profile Details"
            },
        ])
    }, [user?.language]);

    const getProfileInfo = async () => {
        dispatch(setLoading(true))
        const fetchProfileInfo = await ApiCall('get', 'profile-info', null, user.token)
        dispatch(setLoading(false))

        if (fetchProfileInfo && fetchProfileInfo?.data?.success) {
            const info = fetchProfileInfo.data.data
            setState({
                ...state,
                first_name: info.first_name,
                last_name: info.last_name,
                email: info.email,
                phone: info.phone,
                tax_number: info.tax_number,
                profile_picture: info.profile_picture,
                country_code: info.country_code,
                birth_date: info.birth_date ? moment(info.birth_date).format('YYYY-MM-DD') : ''
            })

            setTempState({
                ...tempState,
                first_name: info.first_name,
                last_name: info.last_name,
                email: info.email,
                phone: info.phone,
                tax_number: info.tax_number,
                profile_picture: info.profile_picture,
                country_code: info.country_code,
                birth_date: info.birth_date ? moment(info.birth_date).format('YYYY-MM-DD') : ''
            })

            //     let udetails = {}
            //     udetails.userDetails = {...info}
            //    dispatch(setUserDetails(udetails))
            // if (inputRef?.current) {

            //     inputRef?.current?.setCountry(info.country_code)

            // }
            setPhone(info.phone)

        } else {
            if (fetchProfileInfo?.data?.message == 'Unauthorized' || fetchProfileInfo?.data?.error == 'Unauthorized') {
                dispatch(setLogout())
                navigate('/' + userLang + '/login')
            }
        }
    };

    useEffect(() => {
        (async () => {
            await getProfileInfo()
        })();
    }, []);

    useEffect(() => {
        setIsEdit(false)
        setState(tempState)
    }, [location]);


    const changeValue = (e) => {
        let value = e.target.value;
        setState({
            ...state,
            [e.target.name]: value
        })
    };

    const handleNumberChange = (e) => {
        setPhone(e)
        const instance = inputRef?.current?.getInstance();
        let countryData = instance?.getSelectedCountryData();
        setCountryCode(countryData?.iso2)
    };

    const handleValidityChange = (isValid) => {
        if (phone) {
            if (!isValid) {
                setPhoneError('Invalid phone number')
            } else {
                setPhoneError('')

            }
        } else {
            setPhoneError('Phone number is required')
        }
    };


    // const geoIpLookup = (success, failure) => {
    //     fetch("https://api.ipify.org?format=json")
    //         .then((response) => response.json())
    //         .then((data) => {
    //             const ip = data.ip;
    //             return fetch(`https://ipapi.co/${ip}/country/`);
    //         })
    //         .then((response) => response.text())
    //         .then((countryCode) => {
    //             success(countryCode.toLowerCase()); // Call success callback with ISO2 code
    //         })
    //         .catch(() => {
    //             failure();
    //         });
    // }

    const handleFileChange = (e) => {

        const file = e.target.files[0];

        if (!file) {
            setState({
                ...state,
                error: { profile_picture: "Please select an image" }
            });
            e.target.value = "";
            return;
        }

        const fileExtension = file.name.split('.').pop().toLowerCase();

        if (!allowedImageExtensions.includes(fileExtension)) {
            setState({
                ...state,
                error: { profile_picture: `Invalid image file. Allowed extensions are ${allowedImageExtensions.join(', ')}.` }
            });
            e.target.value = "";
            return;
        }

        if (file.size > maxImageSize) {
            setState({
                ...state,
                error: { profile_picture: `File size should be less than ${maxImageSize / (1024 * 1024)} MB.` }
            });
            e.target.value = "";
            return;
        }

        const reader = new FileReader();

        reader.onload = (event) => {
            const img = new Image();
            img.src = event.target.result;

            img.onload = () => {

                if (img.width < profileImageMinWidth || img.height < profileImageMinHeight) {
                    setState({
                        ...state,
                        error: {
                            profile_picture: `Image dimensions must be at least ${profileImageMinWidth}x${profileImageMinHeight} pixels.`
                        }
                    });
                    e.target.value = "";
                    return;
                }
                e.target.value = "";
                openCropperModal(file);
            };
        };

        reader.readAsDataURL(file);
    };

    const openCropperModal = (file) => {
        setImageName(file.name);
        const reader = new FileReader();

        reader.onload = () => {
            setOriginalImage(reader.result);
            setShowModal(true);

            // Cleanup any previous cropper instance
            if (cropperInstance) {
                cropperInstance.destroy();
                setCropperInstance(null);
            }
        };

        reader.readAsDataURL(file);
    };

    const initializeCropper = () => {
        if (cropperImageRef.current && originalImage) {
            const cropper = new Cropper(cropperImageRef.current, {
                // aspectRatio: 1,
                aspectRatio: profileImageMinWidth / profileImageMinHeight,
                viewMode: 1,
                autoCropArea: 1,
                ready: function () {

                    cropper.setCropBoxData({
                        left: 0,
                        top: 0,
                        width: profileImageMinWidth,
                        height: profileImageMinHeight
                    });
                }
            });
            setCropperInstance(cropper);
        }
    };

    const handleCrop = () => {

        if (cropperInstance) {
            // const croppedCanvas = cropperInstance.getCroppedCanvas();
            const croppedCanvas = cropperInstance.getCroppedCanvas({
                width: profileImageMinWidth, // Set a maximum width
                height: profileImageMinHeight, // Set a maximum height
            });


            if (!croppedCanvas) {
                let msg = 'Something went wrong, please try again';
                setState({
                    ...state,
                    error: {
                        profile_picture: msg
                    }
                })
                return;
            }
            const originalMimeType = cropperInstance.getImageData().type;
            croppedCanvas.toBlob(async (blob) => {

                if (!blob) {
                    let msg = 'Something went wrong, please try again';
                    setState({
                        ...state,
                        error: {
                            profile_picture: msg
                        }
                    })
                    return;
                } else {
                    dispatch(setLoading(true))

                    const mimeType = blob?.type; // Example: "image/png"
                    const extension = mimeType?.split("/")[1];

                    let formData = new FormData();
                    const file = new File([blob], 'cropped_image.' + extension, { type: mimeType });
                    // formData.append('croppedImage', blob, imageName);
                    formData.append('croppedImage', file);

                    const uploadImage = await ApiCall('post', 'upload-profile-image', formData, user.token);
                    dispatch(setLoading(false))
                    if (uploadImage && uploadImage?.data?.success) {
                        var microtime = (Date.now() % 1000) / 1000;

                        setState({
                            ...state,
                            error: {},
                            profile_picture: (uploadImage?.data?.image + '?ver=' + microtime)
                        })

                        setTempState({
                            ...tempState,
                            // profile_picture: uploadImage?.data?.image
                            profile_picture: (uploadImage?.data?.image + '?ver=' + microtime)
                        })
                        let udetails = {}
                        udetails.userDetails = { ...user?.userDetails }
                        udetails.userDetails.profile_picture = uploadImage?.data?.image + '?ver=' + microtime
                        dispatch(setUserDetails(udetails))
                        setShowModal(false);
                        ToastAlert({ msg: uploadImage?.data?.message, msgType: 'success' });
                    } else {
                        setShowModal(false);
                        if (uploadImage?.data?.message == 'Unauthorized' || uploadImage?.data?.error == 'Unauthorized') {
                            dispatch(setLogout())
                            navigate('/' + userLang + '/login')
                        }
                        if (uploadImage?.data?.message) {

                            ToastAlert({ msg: uploadImage?.data?.message, msgType: 'error' });
                        } else {
                            if (uploadImage?.data?.errors?.croppedImage) {
                                ToastAlert({ msg: uploadImage?.data?.errors?.croppedImage, msgType: 'error' });
                            } else {
                                ToastAlert({ msg: 'Something went wrong', msgType: 'error' });
                            }

                        }

                    }
                }
                // }, originalMimeType, 0.9);
            }, originalMimeType, 1);

        }
    };


    // useEffect(() => {
    //     if (flatpickrInstance) {
    //         flatpickrInstance?.destroy();
    //     }
    //     const currentMonth = new Date().getMonth(); // 0-indexed (Jan = 0)
    //     const currentYear = new Date().getFullYear();
    //     if (calendarRef?.current) {

    //         const instance = flatpickr(calendarRef?.current, {
    //             // showMonths: 1,
    //             dateFormat: "Y-m-d",
    //             // inline: true,
    //             // minDate: new Date(),
    //             maxDate: "today",
    //             locale: {
    //                 firstDayOfWeek: 1,

    //             },
    //             // mode: "range",

    //             // defaultMonth: currentMonth, // Always use current month
    //             // defaultYear: currentYear,   // Always use current year
    //             defaultDate: state.birth_date,

    //             onReady: function (selectedDates, dateStr, instance) {

    //                 // instance.input.style.display = 'none';

    //             },
    //             onChange: function (selectedDates, dateStr, instance) {

    //                 setDate(dateStr)
    //                 setState({
    //                     ...state,
    //                     birth_date: dateStr
    //                 })


    //             },

    //         });
    //         setFlatpickrInstance(instance);
    //     }



    // }, [isEdit, state.birth_date]);

    const onClickSaveProfile = (e) => {

        e?.preventDefault();
        setState({
            ...state,
            error: {}
        })



        const rules = {
            first_name: 'required|string',
            last_name: 'required|string',
            birth_date: 'required',
            // phone: 'required',

        }


        const message = {
            'first_name.required': 'First name is required',
            'last_name.required': 'Last name is required',
            'birth_date.required': 'Birth date is required',
            'phone.required': 'Phone number is required',
        }
        validateAll(state, rules, message).then(async () => {
            const formaerrror = {};



            if (phoneError != '') {
                formaerrror['country_code'] = phoneError
            }

            if (!phone) {
                formaerrror['country_code'] = 'Phone number is required.'
            }


            if (!countryCode && phone) {
                formaerrror['country_code'] = 'Please select country.'
            }




            setState({
                ...state,
                error: formaerrror
            })

            if (Object.keys(formaerrror).length) {
                return false;
            }


            setState({
                ...state,
                error: {}
            })
            let data = {}
            data.first_name = state.first_name
            data.last_name = state.last_name
            data.phone = phone
            data.country_code = countryCode
            data.birth_date = state.birth_date

            let tempdta = { ...state }
            tempdta.phone = phone


            dispatch(setLoading(true))
            const saveProfile = await ApiCall('post', 'profile-save', data, user.token)
            dispatch(setLoading(false))
            if (saveProfile) {

                if (saveProfile?.data?.success) {
                    setTempState(tempdta)
                    setState(tempdta)
                    ToastAlert({ msg: saveProfile.data.message, msgType: 'success' });
                    let udetails = {}
                    udetails.userDetails = { ...saveProfile.data.userInfo }
                    udetails.userDetails.profile_picture = state.profile_picture
                    dispatch(setUserDetails(udetails))
                    setIsEdit(false)
                } else {

                    if (saveProfile?.data?.message == 'Unauthorized' || saveProfile?.data?.error == 'Unauthorized') {
                        dispatch(setLogout())
                        navigate('/' + userLang + '/login')
                    }

                    if (saveProfile?.data.errors && Object.keys(saveProfile?.data?.errors).length) {

                        setState({
                            ...state,
                            error: saveProfile?.data?.errors,
                        })

                    } else {
                        const formaerrror = {};
                        formaerrror.first_name = saveProfile?.data?.message
                        setState({
                            ...state,
                            error: formaerrror,
                        })
                    }

                }
            } else {
                ToastAlert({ msg: 'Something went wrong', msgType: 'error' });
            }





        }).catch(errors => {
            dispatch(setLoading(false))
            const formaerrror = {};
            // console.log(errors);

            if (errors.length) {
                if (errors[0]?.field) {
                    document.getElementById(errors[0]?.field)?.focus();
                }
                errors.forEach(element => {
                    formaerrror[element.field] = element.message
                });
            } else {
                ToastAlert({ msg: errors?.message ?? 'Something went wrong', msgType: 'error' });
            }

            setState({
                ...state,
                error: formaerrror,
            })

        });

    };

    const handleChangeDate = (e) => {

        setState({
            ...state,
            birth_date: moment(e).format('YYYY-MM-DD')
        })


    }

    useEffect(() => {


        if (inputRef?.current != null && inputRef.current?.setNumber) {
            // Update the phone number programmatically if needed
            inputRef.current?.setNumber(phone);
            inputRef.current?.setCountry(countryCode);
        }
    }, [phone, countryCode]);

    useEffect(() => {
        setState({
            ...state,
            error: {}
        });
        if (!showModal) {
            if (cropperInstance) {
                cropperInstance.destroy();
                setCropperInstance(null);
            }
        }
    }, [showModal]);

    return (
        <>
            <PageTitle title="Profile" />
            {
                isEdit ?
                    <>
                        <Form
                            state={state}
                            changeValue={changeValue}
                            handleNumberChange={handleNumberChange}
                            handleValidityChange={handleValidityChange}
                            phone={phone}
                            phoneError={phoneError}
                            countryCode={countryCode}
                            initialCountry={initialCountry}
                            inputRef={inputRef}
                            handleFileChange={handleFileChange}
                            calendarRef={calendarRef}
                            onClickSaveProfile={onClickSaveProfile}
                            date={date}
                            setDate={setDate}
                            handleChangeDate={handleChangeDate}
                            navigate={navigate}
                        // geoIpLookup={geoIpLookup}
                        />
                        <CropImageModal
                            show={showModal}
                            handleClose={handleClose}
                            initializeCropper={initializeCropper}
                            cropperImageRef={cropperImageRef}
                            originalImage={originalImage}
                            handleCrop={handleCrop}
                        />
                    </>
                    :
                    <Index
                        state={state}
                        setIsEdit={setIsEdit}
                    />
            }


        </>

    )

}